export default __webpack_public_path__ + "static/service-single-header-3851de6a66f1030eb5a12b3c5f5871f0.jpg";